import { ZERO } from '@snap-types/types/decimal';

import {
  CalculateProductOptionPriceParams,
  CalculateProductOptionPriceResult,
} from './types';

export function calculateLotPriceAddition({
  option,
  quantity,
}: CalculateProductOptionPriceParams): CalculateProductOptionPriceResult {
  if (quantity.lte(ZERO)) {
    return {
      isSuccess: false,
      error: 'Quantity must be greater than 0',
      calculationMode: option.calculationMode,
    };
  }

  if (!option.minimumLotCharge) {
    return {
      isSuccess: false,
      error: 'Missing minimumLotCharge',
      calculationMode: option.calculationMode,
    };
  }

  const sortedLotPrices = option.lotPrices.sort((a, b) =>
    a.qty.minus(b.qty).toNumber(),
  );

  const unmetThresholdIndex = sortedLotPrices.findIndex((lot) =>
    lot.qty.greaterThan(quantity),
  );

  // If unmetThresholdIndex is 0, then the quantity is less than the first lot quantity,
  // so we use the minimumLotCharge
  if (unmetThresholdIndex === 0) {
    const unitPriceAddition = option.minimumLotCharge.dividedBy(quantity);

    return {
      isSuccess: true,
      unitPriceAddition,
      calculationMode: option.calculationMode,
    };
  }

  let lotPrice = null;

  // If unmetThresholdIndex is -1, then the quantity is greater than or equal to the
  // last lot quantity, so we use the last lot price
  if (unmetThresholdIndex === -1) {
    lotPrice = sortedLotPrices[sortedLotPrices.length - 1];
  } else {
    lotPrice = sortedLotPrices[unmetThresholdIndex - 1];
  }

  if (!lotPrice) {
    return {
      isSuccess: false,
      error: 'Missing lot price',
      calculationMode: option.calculationMode,
    };
  }

  return {
    isSuccess: true,
    unitPriceAddition: lotPrice.unitPrice,
    calculationMode: option.calculationMode,
  };
}
